import { Flex, Stack, Box, Text, Image, FlexProps, Spinner } from '@chakra-ui/react';
import logo from '@/assets/icon/logo.svg';

export default function LoadingPage({ ...props }: FlexProps) {
  return (
    <Flex
      h="100%"
      maxW="100dvw"
      minH="100dvh"
      position="relative"
      alignItems="center"
      justifyContent="center"
      {...props}
    >
      <Flex position="absolute" top="4" left="4" alignItems="center" gap="2">
        <Box display="flex" alignItems="center" justifyContent="center" overflow="hidden">
          <Image src={logo} objectFit={'cover'} w="100%" h="32px" />
        </Box>
      </Flex>
      <Stack alignItems="center" gap="24px">
        <Text fontSize="20px" fontWeight="semibold" color="neutrals.700">
          Loading your interview...
        </Text>
        <Text fontSize="16px" color="neutrals.500" textAlign="center">
          Please wait while we prepare everything for you
        </Text>
        <Spinner mt="16px" size="lg" borderWidth="4px" color="primary.900" />
      </Stack>
    </Flex>
  );
}
